import {
  createBrowserRouter,
} from "react-router-dom";
import { useEffect } from "react";

import { AuthLayout } from "../components/layouts/AuthLayout";

import { Login } from "../pages/Auth/Login";
import { ApiProvider } from "../providers/api/apiProvider";
import { Error404 } from "../pages/Error";
import { isCentralAuthEnabled, redirectToCentralAuth } from "../services/authServices";
import { Loading } from "../components/Loading";

const AuthEntry = () => {
  const centralAuthEnabled = isCentralAuthEnabled();

  useEffect(() => {
    if( centralAuthEnabled ) redirectToCentralAuth();
  }, [ centralAuthEnabled ]);

  if( centralAuthEnabled ) return <Loading opacity="none" />;

  return <AuthLayout />;
};

export const authRouter = createBrowserRouter([
  {
    path: "/",
    Component: ApiProvider,
    children: [
      {
        path: "",
        Component: AuthEntry,
        children: [
          {
            path: "",
            Component: Login,
          },
        ]
      },
    ]
  },
  {
    path: "*",
    Component: Error404,
  }
]);
